import { MyAccountTrackingPoint } from '@shopee-user/tracking-constants';

import { PageType } from '../constants';

const MyAccountTrackingSchema: Record<MyAccountTrackingPoint, string> = {
  [MyAccountTrackingPoint.PageView]: '',
  [MyAccountTrackingPoint.ChangePasswordButtonClick]: '',
  [MyAccountTrackingPoint.BackButtonClick]: '',
  [MyAccountTrackingPoint.PhoneInfoButtonClick]: '',
  [MyAccountTrackingPoint.EmailInfoButtonClick]: '',
  [MyAccountTrackingPoint.LogoutButtonClick]: '',
  [MyAccountTrackingPoint.LogoutPopupImpression]: '',
  [MyAccountTrackingPoint.LogoutPopupConfirmButton]: '',
  [MyAccountTrackingPoint.LogoutPopupCancelButton]: '',
  [MyAccountTrackingPoint.LinkWithShopeeAccountClick]: '',
  [MyAccountTrackingPoint.LinkToADifferentShopeeAccountClick]: '',
  [MyAccountTrackingPoint.LoginWithPasscodeButtonClick]: '',
  [MyAccountTrackingPoint.ReturnToPartnerAccountButtonClick]: '',
  [MyAccountTrackingPoint.DeleteAccountButtonClick]: '',
  [MyAccountTrackingPoint.QuickLoginToggleClick]: '',
  [MyAccountTrackingPoint.QuickLoginLogoutPopupImpression]: '',
  [MyAccountTrackingPoint.QuickLoginLogoutConfirmButton]: '',
  [MyAccountTrackingPoint.QuickLoginLogoutBackButton]: '',
};

export const getMyAccountPageTypeAndSchema = (
  trackingPoint: MyAccountTrackingPoint
) => {
  return {
    page_type: PageType.MyAccountPage,
    schema: MyAccountTrackingSchema[trackingPoint],
  };
};
